import styled from "styled-components";

import LargeText from "./LargeText";

const BodyText = styled(LargeText)`
  margin-bottom: ${props => props.theme.spacingSmall};
`;

export default BodyText;
